import { useCallback, useRef } from 'react';

// Discards responses from superseded requests so an old period's data never renders under a new selection.
export function useLatestRequest() {
  const seq = useRef(0);
  return useCallback(() => {
    const id = ++seq.current;
    return () => id === seq.current;
  }, []);
}
